import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';

@Component({
  selector: 'app-feedbackform',
  templateUrl: './feedbackform.component.html',
  styleUrls: ['./feedbackform.component.scss']
})
export class FeedbackformComponent implements OnInit {
  savingFlag: boolean = false;
  form: any = {};
  employee_id: any
  pageType: any;
  constructor(public rout: Router, public toast: ToastrManager, public service: DatabaseService, public route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.employee_id = params.id;
      this.form.employee_id = params.id;
    });

  }

  goBack() {
    window.history.back();
  }

  submitForm() {
    this.savingFlag = true;
    this.service.post_rqst({ 'data': this.form }, "CronJob/eventFeedback").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.savingFlag = false;
        this.rout.navigate(['/thanks/' + this.employee_id]);
      }
      else {
        this.toast.errorToastr(result['statusMsg']);
        this.savingFlag = false;
      }
    }, err => {
      this.savingFlag = false;
    })
  }





}
